module.exports = __webpack_public_path__ + "img/brown-carpet-grass-01.8516c0d3.png";